import { Component } from '@angular/core';
import { Event, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { filter, take, tap } from 'rxjs/operators';
import { DesktopNotificationsService } from '@dta/ui/services/desktop-notifications/desktop-notifications.service';
import { deeplinkRoute } from '@shared/modules/deeplinks/common/constants/deeplink-route';

@Component({
  selector: 'web-root',
  templateUrl: './web.component.html',
  styleUrls: ['./web.component.scss'],
  imports: [RouterOutlet]
})
export class WebComponent {
  constructor(
    private _router: Router,
    private _desktopNotificationService: DesktopNotificationsService
  ) {
    this.subscribeToRouterEvents();
  }

  private startSyncAndLogger() {
    // Init Desktop notifications
    this._desktopNotificationService.subscribeToDesktopNotifications();
  }

  private subscribeToRouterEvents() {
    this._router.events
      .pipe(
        filter((event: Event) => event instanceof NavigationStart),
        filter((event: NavigationStart) => !event.url.includes('/' + deeplinkRoute)),
        take(1),
        tap(() => {
          this.startSyncAndLogger();
        })
      )
      .subscribe();
  }
}
